var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10L3.277 11.43a.667.667 0 01-.967-.702l.52-3.032L.627 5.549a.667.667 0 01.37-1.137L4.04 3.97 5.402 1.21a.667.667 0 011.196 0L7.959 3.97l3.045.442a.667.667 0 01.369 1.137L9.17 7.697l.52 3.032a.667.667 0 01-.967.702L6 10z",
    fill: "var(--color-green-pantone)"
  })));
};

export default SvgStar;